import {
  List,
  TextField,
  EditButton,
  Datagrid,
  SimpleList,
  ReferenceField,
  ReferenceInput,
  SelectInput,
  TopToolbar,
  CreateButton,
} from "react-admin";
import { getPermissions } from "auth/security/securityUtils";
import { checkPermission } from "server/security/utils";
import permissions from "app/permissions";
import SecuredComponent from "server/security/SecuredComponent";
import GradesPopup from "./GradesPopup";
import { MOBILE_BREAKPOINT } from "utils/constants";
import { useMediaQuery } from "@mui/material";
import { settings } from "app";
import { EmptyList } from "server/components";
import DepartmentInput from "./DepartmentInput";
import { ExportXlsButton } from "features/ExportXlsxButton";
import { GradingScalesExporter } from "./XlsxExporter";
import { administrationRequests } from "api/administrationApi";
import { MobileListRow } from "features/MobileListRow";

const ListGradingScales = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const userPermissions = getPermissions();

  const ListActions = hasCreate => {
    return (
      <TopToolbar>
        {hasCreate && <CreateButton />}
        <ExportXlsButton exporter={GradingScalesExporter} />
      </TopToolbar>
    );
  };

  return (
    <>
      <List
        actions={<ListActions hasCreate={checkPermission(userPermissions, permissions.canCreateGradingScales)} />}
        title="Скали за оценяване"
        filters={[
          <ReferenceInput
            key={1}
            source="directionId"
            reference={administrationRequests.getDirectionsSelect()}
            filter={{ filterByUser: true }}
            label="Направление"
            alwaysOn
          >
            <SelectInput
              sx={{ minWidth: 300 }}
              label="Направление"
              emptyText="Всички"
            />
          </ReferenceInput>,
          <DepartmentInput
            key={2}
            alwaysOn
            sx={{ minWidth: 300 }}
          />,
        ]}
      >
        {isMobile ? (
          <SimpleList
            empty={<EmptyList />}
            linkType={false}
            sx={settings.style.mobileList}
            primaryText={record => <MobileListRow fields={[{ label: "Име", value: record.name }]} />}
            secondaryText={record => (
              <div>
                <MobileListRow fields={[{ label: "Точки", value: record.maxPoints }]} />
                <MobileListRow
                  fields={[
                    {
                      label: "Направление",
                      value: (
                        <ReferenceField
                          source="directionId"
                          reference={administrationRequests.getDirectionsSelect()}
                          label="Направление"
                        />
                      ),
                    },
                  ]}
                />
                <MobileListRow
                  fields={[
                    {
                      label: "Катедра",
                      value: (
                        <ReferenceField
                          source="departmentId"
                          reference={administrationRequests.getDepartmentsSelect()}
                          label="Катедра"
                        />
                      ),
                    },
                  ]}
                />
              </div>
            )}
            tertiaryText={() => (
              <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                <GradesPopup label="" />
                <SecuredComponent permission={permissions.canUpdateGradingScales}>
                  <EditButton label="" />{" "}
                </SecuredComponent>
              </div>
            )}
          />
        ) : (
          <Datagrid
            bulkActionButtons={false}
            rowClick={false}
          >
            <TextField
              source="name"
              label="Име"
              sortable={false}
            />
            <TextField
              source="maxPoints"
              label="Точки"
              sortable={false}
            />
            <ReferenceField
              source="directionId"
              reference={administrationRequests.getDirectionsSelect()}
              label="Направление"
            />

            <ReferenceField
              source="departmentId"
              reference={administrationRequests.getDepartmentsSelect()}
              label="Катедра"
            />
            <GradesPopup />
            <SecuredComponent permission={permissions.canUpdateGradingScales}>
              <EditButton />
            </SecuredComponent>
          </Datagrid>
        )}
      </List>
    </>
  );
};

export default ListGradingScales;
